import type {
  ResponseAcademicRisk,
  SemesterAcademicRisk,
} from '@/domains/academicRisk/academicRiskStudent.entity';
import type { SemesterKey } from '@/domains/shared';

/**
 * Use Case para filtrar estudiantes vigentes
 *
 * Responsabilidades:
 * - Filtrar estudiantes donde vigente = true
 * - Mantener estructura de año > semestre
 * - Validar integridad de datos
 */
export class FilterVigenteStudentsUseCase {
  /**
   * Ejecuta el filtrado de estudiantes vigentes
   * @param response - Respuesta completa de la API
   */
  execute(response: ResponseAcademicRisk): ResponseAcademicRisk {
    if (!response?.data) {
      return { data: {} };
    }

    const filteredYears: ResponseAcademicRisk['data'] = {};

    for (const [year, semesters] of Object.entries(response.data)) {
      filteredYears[year] = {} as SemesterAcademicRisk;

      for (const [semester, students] of Object.entries(semesters)) {
        filteredYears[year][semester as SemesterKey] = students.filter(
          (student) => student.vigente === true,
        );
      }
    }

    return { data: filteredYears };
  }
}
